import { getProfile } from "@/api/profile";
import { ProfileType } from "@/types/profile";
import { useQuery } from "@tanstack/react-query";

export const useProfile = () => {
  return useQuery<ProfileType | null, Error>({
    queryFn: getProfile,
    queryKey: ["profile"],
    refetchOnMount: true,
    retry: 2,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
